// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Experience-module--cds--assistive-text--0b61f";
export var cdsHideFeedback = "Experience-module--cds--hide-feedback--3953c";
export var cdsShowFeedback = "Experience-module--cds--show-feedback--bcae6";
export var cdsSkeleton = "Experience-module--cds--skeleton--31402";
export var cdsVisuallyHidden = "Experience-module--cds--visually-hidden--7f261";
export var experience = "Experience-module--experience--6d278";
export var experienceContainer = "Experience-module--experience-container--2f3f8";
export var selected = "Experience-module--selected--158f8";